import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="bg-paper" data-id="element-41" data-mp="1lcaauyfbbwz7">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 py-12 lg:grid-cols-[0.7fr_1.3fr] lg:py-24" data-id="element-42" data-mp="1gdgxr73xu7zk">
        <h2 id="faq-title" className="font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-43" data-mp="2e0ppvkyg2faj">
          Frequently asked questions
        </h2>
        <ul className="border-t-2 border-ink" data-id="element-44" data-mp="2429xlenokzzg">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={f.q} className="border-b-2 border-ink" data-id="element-45" data-mp="1z2xcaycgk0yz" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-4 text-left font-display text-base font-extrabold focus:outline-none focus-visible:text-rust-dark sm:py-5 sm:text-xl" data-id="element-46" data-mp="snd67y40xyox">
                  {f.q}
                  <PlusIcon className={`h-6 w-6 shrink-0 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-47" data-mp="ugitqx9onh7s" />
                </button>
                <AnimatePresence initial={false} data-id="element-48" data-mp="kh09sgtrvvfq">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-49" data-mp="6r6ilrusoz2u">
                      <p className="pb-5 pr-6 text-base leading-relaxed text-ink-soft sm:pb-6 sm:pr-10 sm:text-lg" data-id="element-50" data-mp="3t0hhho62th8c">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}